import { combineReducers } from 'redux';
import users from './usersReducers';
import gameDevelopers from './gameDevelopersReducers';

export default combineReducers({
  usersReducer: users,
  gameDevelopersReducer: gameDevelopers
});


/** WEBPACK FOOTER **
 ** ./src/reducers/reducers.js
 **/